import { createSlice } from "@reduxjs/toolkit";
import { QueryListResult } from "../models/TR-CR-Query/Query-List-Result";

interface QueryState {
  queryList: QueryListResult;
  allQueryResult: {
    LIST?: any[];
    MAIN?: any[];
    ERROR?: any[];
  };
}

const initialState: QueryState = {
  queryList: null,
  allQueryResult: null
};

const queryStore = createSlice({
  name: "query",
  initialState,
  reducers: {
    getQueryList: (state) => {
      state.queryList;
    },
    updateQueryList: (state, action) => {
      state.queryList = {
        ...state.queryList,
        ...action.payload.queryList
      };
    },
    resetQueryList: (state) => {
      state.queryList = null;
    },
    getAllQueryList: (state) => {
      state.allQueryResult;
    },
    updateAllQueryList: (state, action) => {
      state.allQueryResult = {
        ...state.allQueryResult,
        ...action.payload.allQueryResult
      };
    },
    resetAllQueryResult: (state) => {
      state.allQueryResult = null;
    }
  }
});

export const { getQueryList, updateQueryList, resetQueryList, getAllQueryList, updateAllQueryList, resetAllQueryResult } = queryStore.actions;

export default queryStore.reducer;
